// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SuncSpravochnik_container__dLc7f {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;
  color: #333;
}

.SuncSpravochnik_card__mhi\\+o {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  margin-bottom: 2rem;
}

.SuncSpravochnik_title__alXy0 {
  text-align: center;
  margin-bottom: 1.5rem;
  color: rgb(33.1380753138, 125.1882845188, 186.8619246862);
}

.SuncSpravochnik_form__FZ1B9 {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.SuncSpravochnik_formGroup__p3VEx {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.SuncSpravochnik_label__fLhjR {
  font-weight: 600;
  font-size: 1.1rem;
}

.SuncSpravochnik_fileInput__SRYAl {
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  transition: border-color 0.3s;
}
.SuncSpravochnik_fileInput__SRYAl:focus {
  outline: none;
  border-color: #3498db;
}

.SuncSpravochnik_submitButton__cQ9Fx {
  background-color: #3498db;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}
.SuncSpravochnik_submitButton__cQ9Fx:hover:not(:disabled) {
  background-color: rgb(33.1380753138, 125.1882845188, 186.8619246862);
}
.SuncSpravochnik_submitButton__cQ9Fx:disabled {
  background-color: rgb(138.6359832636, 195.9581589958, 234.3640167364);
  cursor: not-allowed;
}

.SuncSpravochnik_spinner__29bz4 {
  width: 1rem;
  height: 1rem;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: SuncSpravochnik_spin__5PJd8 1s ease-in-out infinite;
}

@keyframes SuncSpravochnik_spin__5PJd8 {
  to {
    transform: rotate(360deg);
  }
}
.SuncSpravochnik_errorAlert__8SX7D {
  margin-top: 1.5rem;
  padding: 1rem;
  background-color: rgb(250.5616438356, 221.897260274, 218.9383561644);
  border-left: 4px solid #e74c3c;
  color: rgb(213.698630137, 43.8356164384, 26.301369863);
  border-radius: 4px;
}

.SuncSpravochnik_resultsContainer__p9FVr {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 2rem;
}

.SuncSpravochnik_resultsHeader__aJh0J {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #ddd;
}

.SuncSpravochnik_resultsCount__6k2\\+n {
  background-color: #f5f5f5;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.9rem;
}

.SuncSpravochnik_tableWrapper__5IK0U {
  overflow-x: auto;
  margin-top: 1rem;
}

.SuncSpravochnik_resultsTable__\\+4lM0 {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.95rem;
}
.SuncSpravochnik_resultsTable__\\+4lM0 th, .SuncSpravochnik_resultsTable__\\+4lM0 td {
  padding: 0.75rem 1rem;
  text-align: left;
  border: 1px solid #ddd;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.SuncSpravochnik_resultsTable__\\+4lM0 th {
  background-color: #f5f5f5;
  font-weight: 600;
}
.SuncSpravochnik_resultsTable__\\+4lM0 tr:nth-child(even) {
  background-color: rgba(245, 245, 245, 0.5);
}
.SuncSpravochnik_resultsTable__\\+4lM0 tr:hover {
  background-color: rgba(52, 152, 219, 0.05);
}

@media (max-width: 768px) {
  .SuncSpravochnik_container__dLc7f {
    padding: 1rem;
  }
  .SuncSpravochnik_card__mhi\\+o, .SuncSpravochnik_resultsContainer__p9FVr {
    padding: 1.5rem;
  }
  .SuncSpravochnik_resultsHeader__aJh0J {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
}
@media (max-width: 480px) {
  .SuncSpravochnik_form__FZ1B9 {
    gap: 1rem;
  }
  .SuncSpravochnik_submitButton__cQ9Fx {
    width: 100%;
    padding: 0.75rem;
  }
  .SuncSpravochnik_resultsTable__\\+4lM0 {
    font-size: 0.85rem;
  }
  .SuncSpravochnik_resultsTable__\\+4lM0 th, .SuncSpravochnik_resultsTable__\\+4lM0 td {
    padding: 0.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/SuncSpavochnik/SuncSpravochnik.module.scss"],"names":[],"mappings":"AAyBA;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAzBW;AACb;;AA2BA;EAbE,iBAAA;EACA,kBAAA;EACA,wCAdO;EAeP,aAAA;EAYA,mBAAA;AArBF;;AAwBA;EACE,kBAAA;EACA,qBAAA;EACA,yDAAA;AArBF;;AAwBA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AArBF;;AAwBA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AArBF;;AAwBA;EACE,gBAAA;EACA,iBAAA;AArBF;;AAwBA;EACE,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;AArBF;AAuBE;EACE,aAAA;EACA,qBApEY;AA+ChB;;AAyBA;EACE,yBAzEc;EA0Ed,YAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,iCAAA;EApEA,aAAA;EACA,uBAAA;EACA,mBAAA;EAoEA,WAAA;AApBF;AAsBE;EACE,oEAAA;AApBJ;AAuBE;EACE,qEAAA;EACA,mBAAA;AArBJ;;AAyBA;EACE,WAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,uBAAA;EACA,8DAAA;AAtBF;;AAyBA;EACE;IAAK,yBAAA;EArBL;AACF;AAuBA;EACE,kBAAA;EACA,aAAA;EACA,oEAAA;EACA,8BAAA;EACA,sDAAA;EACA,kBAAA;AArBF;;AAwBA;EAlGE,iBAAA;EACA,kBAAA;EACA,wCAdO;EAeP,aAAA;AA8EF;;AAqBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,oBAAA;EACA,6BAAA;AAlBF;;AAqBA;EACE,yBA9HW;EA+HX,wBAAA;EACA,mBAAA;EACA,iBAAA;AAlBF;;AAqBA;EACE,gBAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;AAlBF;AAoBE;EACE,qBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAlBJ;AAqBE;EACE,yBAzJS;EA0JT,gBAAA;AAnBJ;AAsBE;EACE,0CAAA;AApBJ;AAuBE;EACE,0CAAA;AArBJ;;AA0BA;EACE;IACE,aAAA;EAvBF;EA0BA;IACE,eAAA;EAxBF;EA2BA;IACE,sBAAA;IACA,uBAAA;IACA,WAAA;EAzBF;AACF;AA4BA;EACE;IACE,SAAA;EA1BF;EA6BA;IACE,WAAA;IACA,gBAAA;EA3BF;EA8BA;IACE,kBAAA;EA5BF;EA8BE;IACE,eAAA;EA5BJ;AACF","sourcesContent":["// Переменные\r\n$primary-color: #3498db;\r\n$error-color: #e74c3c;\r\n$success-color: #2ecc71;\r\n$text-color: #333;\r\n$light-gray: #f5f5f5;\r\n$border-color: #ddd;\r\n$shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n$breakpoint-tablet: 768px;\r\n$breakpoint-mobile: 480px;\r\n\r\n// Миксины\r\n@mixin flex-center {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n@mixin card-style {\r\n  background: white;\r\n  border-radius: 8px;\r\n  box-shadow: $shadow;\r\n  padding: 2rem;\r\n}\r\n\r\n.container {\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  padding: 2rem 1rem;\r\n  color: $text-color;\r\n}\r\n\r\n.card {\r\n  @include card-style;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.title {\r\n  text-align: center;\r\n  margin-bottom: 1.5rem;\r\n  color: darken($primary-color, 10%);\r\n}\r\n\r\n.form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1.5rem;\r\n}\r\n\r\n.formGroup {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.label {\r\n  font-weight: 600;\r\n  font-size: 1.1rem;\r\n}\r\n\r\n.fileInput {\r\n  padding: 0.75rem;\r\n  border: 1px solid $border-color;\r\n  border-radius: 4px;\r\n  font-size: 1rem;\r\n  transition: border-color 0.3s;\r\n\r\n  &:focus {\r\n    outline: none;\r\n    border-color: $primary-color;\r\n  }\r\n}\r\n\r\n.submitButton {\r\n  background-color: $primary-color;\r\n  color: white;\r\n  border: none;\r\n  padding: 0.75rem 1.5rem;\r\n  border-radius: 4px;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s;\r\n  @include flex-center;\r\n  gap: 0.5rem;\r\n\r\n  &:hover:not(:disabled) {\r\n    background-color: darken($primary-color, 10%);\r\n  }\r\n\r\n  &:disabled {\r\n    background-color: lighten($primary-color, 20%);\r\n    cursor: not-allowed;\r\n  }\r\n}\r\n\r\n.spinner {\r\n  width: 1rem;\r\n  height: 1rem;\r\n  border: 2px solid rgba(255, 255, 255, 0.3);\r\n  border-radius: 50%;\r\n  border-top-color: white;\r\n  animation: spin 1s ease-in-out infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  to { transform: rotate(360deg); }\r\n}\r\n\r\n.errorAlert {\r\n  margin-top: 1.5rem;\r\n  padding: 1rem;\r\n  background-color: lighten($error-color, 35%);\r\n  border-left: 4px solid $error-color;\r\n  color: darken($error-color, 10%);\r\n  border-radius: 4px;\r\n}\r\n\r\n.resultsContainer {\r\n  @include card-style;\r\n}\r\n\r\n.resultsHeader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 1.5rem;\r\n  padding-bottom: 1rem;\r\n  border-bottom: 1px solid $border-color;\r\n}\r\n\r\n.resultsCount {\r\n  background-color: $light-gray;\r\n  padding: 0.25rem 0.75rem;\r\n  border-radius: 12px;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.tableWrapper {\r\n  overflow-x: auto;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.resultsTable {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 0.95rem;\r\n\r\n  th, td {\r\n    padding: 0.75rem 1rem;\r\n    text-align: left;\r\n    border: 1px solid $border-color;\r\n    max-width: 300px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n  }\r\n\r\n  th {\r\n    background-color: $light-gray;\r\n    font-weight: 600;\r\n  }\r\n\r\n  tr:nth-child(even) {\r\n    background-color: rgba($light-gray, 0.5);\r\n  }\r\n\r\n  tr:hover {\r\n    background-color: rgba($primary-color, 0.05);\r\n  }\r\n}\r\n\r\n// Адаптивные стили\r\n@media (max-width: $breakpoint-tablet) {\r\n  .container {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .card, .resultsContainer {\r\n    padding: 1.5rem;\r\n  }\r\n\r\n  .resultsHeader {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 0.5rem;\r\n  }\r\n}\r\n\r\n@media (max-width: $breakpoint-mobile) {\r\n  .form {\r\n    gap: 1rem;\r\n  }\r\n\r\n  .submitButton {\r\n    width: 100%;\r\n    padding: 0.75rem;\r\n  }\r\n\r\n  .resultsTable {\r\n    font-size: 0.85rem;\r\n\r\n    th, td {\r\n      padding: 0.5rem;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SuncSpravochnik_container__dLc7f`,
	"card": `SuncSpravochnik_card__mhi+o`,
	"title": `SuncSpravochnik_title__alXy0`,
	"form": `SuncSpravochnik_form__FZ1B9`,
	"formGroup": `SuncSpravochnik_formGroup__p3VEx`,
	"label": `SuncSpravochnik_label__fLhjR`,
	"fileInput": `SuncSpravochnik_fileInput__SRYAl`,
	"submitButton": `SuncSpravochnik_submitButton__cQ9Fx`,
	"spinner": `SuncSpravochnik_spinner__29bz4`,
	"spin": `SuncSpravochnik_spin__5PJd8`,
	"errorAlert": `SuncSpravochnik_errorAlert__8SX7D`,
	"resultsContainer": `SuncSpravochnik_resultsContainer__p9FVr`,
	"resultsHeader": `SuncSpravochnik_resultsHeader__aJh0J`,
	"resultsCount": `SuncSpravochnik_resultsCount__6k2+n`,
	"tableWrapper": `SuncSpravochnik_tableWrapper__5IK0U`,
	"resultsTable": `SuncSpravochnik_resultsTable__+4lM0`
};
export default ___CSS_LOADER_EXPORT___;
